import React, { useState } from 'react';
import { Box, Button, IconButton, List, ListItem, Popover, Typography } from '@mui/material';
import Badge from '@mui/material/Badge';
import NotificationsIcon from '@mui/icons-material/Notifications';
import useNotifications from '../../hooks/useNotifications';
import useTranslation from '../../hooks/useTranslation';
import { useHistory } from 'react-router-dom';

const itemStyles = { alignItems: 'flex-start', cursor: 'pointer' };

const NotificationsBell = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { items, unread, markRead, markAllRead } = useNotifications();
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const viewAll = () => {
    handleClose();
    history.push('/admin/notifications');
  };

  const handleItemClick = async (n) => {
    const productId = n?.data?.product_id;
    await markRead(n.id);
    if (productId) {
      handleClose();
      history.push(`/admin/products/edit/${productId}`);
    }
  };

  return (
    <>
      <IconButton color="inherit" onClick={handleOpen} aria-label="notifications">
        <Badge badgeContent={unread} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Box sx={{ width: 380, p: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 1, pb: 1 }}>
            <Typography variant="subtitle1">{t('labels.notifications')}</Typography>
            <Button size="small" onClick={markAllRead}>
              {t('labels.mark_all_read')}
            </Button>
          </Box>
          <List dense>
            {items.map((n) => {
              const productId = n?.data?.product_id;
              const isLink = Boolean(productId);
              return (
                <ListItem
                  key={n.id}
                  sx={itemStyles}
                  onClick={() => handleItemClick(n)}
                >
                  <Box>
                    <Typography
                      variant="body2"
                      fontWeight={600}
                      sx={isLink ? { color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } } : {}}
                    >
                      {n.title}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {n.body}
                    </Typography>
                  </Box>
                </ListItem>
              );
            })}
            {items.length === 0 && (
              <Box sx={{ p: 2, color: 'text.secondary' }}>
                {t('labels.no_new_notifications')}
              </Box>
            )}
          </List>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: 1 }}>
            <Button size="small" onClick={viewAll}>
              {t('labels.view_all')}
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
};

export default NotificationsBell;